import React from 'react';
import classnames from 'classnames';

import { FlexColumn, FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import style from './labeled-field-with-button.module.less';

/**
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @param {string} props.label
 * @param {string} props.labelId
 * @param {string} props.labelFor
 * @param {JSX.Element} props.button
 * @param {boolean} props.hasValidationError
 * @returns {React.ReactNode}
 */
export const LabeledFieldWithButton = ({
  children = null,
  label = '',
  hasValidationError = false,
  labelId = '',
  labelFor = '',
  button = null,
}) => {
  return (
    <FlexColumn className={style.field}>
      <FlexRow className={style['field-label-with-button']}>
        <Text
          className={classnames(style['field-label'], {
            [style['validation-error']]: hasValidationError,
          })}
          htmlFor={labelFor}
          id={labelId}
          textType={TextType.Label}
          value={label}
        />
        {button ? button : null}
      </FlexRow>
      {children}
    </FlexColumn>
  );
};
